<div
  id="PrintComponent"
  class="card esri-widget animation-on-tool-open"
  #printComponentRef
  gisDraggableWidget
>
  <!--- the card header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-9" translate>
        WIDGET.PRINT.PANEL_HEADING
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the card body -->
  <div class="card-body">
    <sbb-print-widget
      [mapView]="mainMapService.mapView"
      [authorDefaultValue]="author"
      [active]="expandWidget.expanded"
      [useScaleDefaultValue]="true"
    >
    </sbb-print-widget>
  </div>
</div>
